import stationDataConfigApi from '@/api/config/stationDataConfig'
import { queryKeys } from '@/constant/common'
import { NotifyService } from '@/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'

async function resetById(payload: any): Promise<void> {
  await stationDataConfigApi.resetId(payload)
}

interface UseStationResetByIdOptions {
  onSuccess?: (data: any) => void
  onError?: (error: any) => void
}

function useStationResetById(options?: UseStationResetByIdOptions) {
  const queryClient = useQueryClient()

  return useMutation((payload: any) => resetById(payload), {
    onSuccess: (data: any) => {
      queryClient.invalidateQueries([queryKeys.errorCode && queryKeys.stations])
      queryClient.invalidateQueries({ queryKey: ['availableStations'] })
      NotifyService.success('Reset Station Success')
      // Call custom onSuccess if provided
      options?.onSuccess?.(data)
    },
    onError: (error: any) => {
      NotifyService.error(error)
      // Call custom onError if provided
      options?.onError?.(error)
    },
  })
}

export default useStationResetById
